import * as React from 'react';
import { removeFilter, flushFilters, Filters, Filter, State as TableState } from 'reducers/tables';
import { bindActionCreators, Dispatch, AnyAction } from 'redux';
import { connect } from 'react-redux';
import Link from 'components/Link';
import Glyph from 'components/Glyph';
import { MouseEventHandler } from 'types/typescript/eventHandlers';

import './styles/SmartTableFilterTokens.scss';

type Props = {
  namespace: string;
};

type ReduxStateProps = {
  filters: Filters | undefined;
};

type ReduxDispatchProps = {
  flushFilters: (namespace: string) => any;
  removeFilter: (namespace: string, filter: Filter) => any;
};

function Token(props: { text?: string; onClose: MouseEventHandler }) {
  return (
    <Link
      className="SmartTableFilterTokens-item"
      eventElementName="SmartTableFilterTokens-item"
      onClick={props.onClose}>
      {props.text && <span className="SmartTableFilterTokens-item-text">{props.text}</span>}
      <Glyph name="close" size="xxsmall" />
    </Link>
  );
}

class SmartTableFilterTokens extends React.Component<Props & ReduxStateProps & ReduxDispatchProps> {
  flush = () => {
    this.props.flushFilters(this.props.namespace);
  };
  removeFilter = (filter: Filter) => {
    this.props.removeFilter(this.props.namespace, filter);
  };
  render() {
    const { filters } = this.props;

    if (filters === undefined || filters.size === 0) {
      return null;
    }

    return (
      <div className="SmartTableFilterTokens">
        <Token onClose={this.flush} />
        {filters
          .valueSeq()
          .toArray()
          .map(filter => (
            <Token key={filter.key} text={filter.name} onClose={() => this.removeFilter(filter)} />
          ))}
      </div>
    );
  }
}

function mapStateToProps(state: { tables?: TableState }, props: Props): ReduxStateProps {
  return {
    filters: state.tables?.get(props.namespace)?.filters,
  };
}

function mapDispatchToProps(dispatch: Dispatch<AnyAction>): ReduxDispatchProps {
  return bindActionCreators({ removeFilter, flushFilters }, dispatch);
}

export { SmartTableFilterTokens };
export default connect<ReduxStateProps, ReduxDispatchProps, Props>(
  mapStateToProps,
  mapDispatchToProps
)(SmartTableFilterTokens);
